<template>
    <div class="container-fluid px-0">
        <div class="container-fluid bg-light fixed-top" style="height: 60px">
            <header class="container">
                <div class="row justify-content-start">
                    <nav class="navbar pr-0">
                        <a class="navbar-brand" :href="baseUrl">
                            <img src="/logo-icon.svg" width="45" height="45" v-on:click="resetTestData" class="d-inline-block align-middle"
                                 alt="Home">
                        </a>
                    </nav>
                    <section class="flex-fill pt-3 pb-0">
                        <div class="container">
                            <div class="progress w-100 rounded-0" style="height: 6px">
                                <div class="progress-bar" role="progressbar" :style="{width: progress + '%'}"
                                     :aria-valuenow="progress"
                                     aria-valuemin="0"
                                     aria-valuemax="100">
                                </div>
                            </div>
                            <div class="progress w-100 rounded-0" style="height: 4px">
                                <div class="progress-bar progress-bar-countdown bg-secondary progress-bar-striped progress-bar-animated"
                                     role="progressbar" :style="{width: stepCountDownProgress + '%'}"
                                     :aria-valuenow="stepCountDownProgress"
                                     aria-valuemin="0"
                                     aria-valuemax="100">
                                </div>
                            </div>

                            <div class="row no-gutters">
                                <div class="flex-fill">
                                    <span class="">{{$t('Step')}}</span> {{currentStepNumber}} / {{stepsCount}}
                                </div>
                                <div class="text-right" v-if="!loading">
                                    <VueCountdown
                                        :time="stepCountdown" ref="countdown"
                                        :transform="transformCountdown"
                                        v-on:progress="handleCountdownProgress"
                                        :auto-start="false"
                                        v-on:end="nextStep">
                                        <template slot-scope="props">
                                            <span>
                                                <span class="d-none d-sm-inline">{{$t('Timer')}}:</span> <strong>{{ props.minutes }}:{{ props.seconds }}</strong>
                                            </span>
                                        </template>
                                    </VueCountdown>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </header>
        </div>

        <section v-if="loading" class="bg-white">
            <div class="container text-center">
                Loading...
            </div>
        </section>

        <section v-if="!loading" class="pt-7 pb-0">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="d-flex flex-row">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" class="vox-icon vox-icon-2x mr-3 fill-secondary">
                                    <use xlink:href="#vox-icon-teachers"></use>
                                </svg>
                            </div>
                            <div class="flex-shrink-1">
                                <h2 class="fs-0 mb-0">
                                    {{currentStep.task}}
                                </h2>
                            </div>
                        </div>
                        <hr class="mb-4">
                    </div>
                </div>
            </div>

            <StepContentDropdowns
                v-if="currentStep.questions_type === 'dropdowns'"
                v-model="answersList"
                v-on:start-countdown="startCountdown"
                v-bind:step="currentStep"></StepContentDropdowns>
            <StepContent
                v-else
                v-on:start-countdown="startCountdown"
                v-bind:step="currentStep"></StepContent>

        </section>

        <section v-if="!loading && currentStep.questions_type !== 'dropdowns'" class="pt-0 pb-0">
            <div class="container" v-if="currentStep.questions">
                <div v-if="currentStep.type !== 'empty'" class="row">
                    <div class="col mt-4">
                        <div class="d-flex flex-row align-items-center">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" class="vox-icon vox-icon-2x mr-3 fill-secondary">
                                    <use xlink:href="#vox-icon-innovative"></use>
                                </svg>
                            </div>
                            <div class="flex-shrink-1">
                                <h2 class="fs-1 fw-medium text-uppercase mb-0">
                                    Questions
                                </h2>
                            </div>
                        </div>
                        <hr>
                    </div>
                </div>

                <div v-for="(question, index) in currentStep.questions" class="mt-3" v-bind:class="{'mb-5' : currentStep.questions.length !== index + 1}">
                    <QuestionRadio
                        v-if="question.type === 'radio'"
                        :key="question.id"
                        v-bind:question="question"
                        v-bind:index="index + 1"
                        v-model="answersList['q' + question.id]"
                    ></QuestionRadio>
                    <QuestionCheckboxes
                        v-else-if="question.type === 'checkboxes'"
                        :question="question"
                        v-model="answersList['q' + question.id]"
                        :key="question.id"></QuestionCheckboxes>
                    <QuestionInputs
                        v-else-if="question.type === 'inputs'"
                        :key="question.id"
                        :value="answersList['q' + question.id]"
                        v-on:input="onInputPart"
                        v-bind:question="question"
                        v-bind:index="index + 1"
                    ></QuestionInputs>
                </div>
            </div>
        </section>



        <section v-if="!loading" class="pt-5 pb-0">
            <div class="container">

                <div class="row justify-content-center">
                    <div class="col-12 col-sm-8 col-lg-4">
                        <button
                            v-if="currentStepNumber === stepsCount"
                                :disabled="!stepAnswered"
                                class="btn btn-primary btn-block rounded-pill text-nowrap"
                                v-on:click="finish">
                            <span>{{$t('Finish')}}</span> <i class="ico vox-mdi-long-arrow-right ml-3"></i>
                        </button>
                        <button v-else
                                :disabled="!stepAnswered"
                                class="btn btn-secondary btn-block rounded-pill text-nowrap"
                                v-on:click="nextStep">
                            <span>{{$t('Next')}}</span>
                            <!--
                            <i class="ico vox-mdi-long-arrow-right ml-3"></i>
                            -->
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <section class="text-center">
            <a class="btn btn-outline-dark rounded rounded-pill" v-on:click="resetTestData" :href="baseUrl">
                {{$t('Exit')}}
            </a>
        </section>

    </div>
</template>

<script>
    import Api from "../services/Api"
    import LocalStorage from "../services/LocalStorage"
    import StepContent from "../components/StepContent"
    import StepContentDropdowns from "../components/StepContentDropdowns"
    import QuestionCheckboxes from "../components/QuestionCheckboxes"
    import QuestionRadio from "../components/QuestionRadio"
    import QuestionInputs from "../components/QuestionInputs"
    import VueCountdown from '@chenfengyuan/vue-countdown'
    import AudioAPI from "../services/AudioAPI"

    export default {
        components: {
            StepContent,
            StepContentDropdowns,
            QuestionRadio,
            QuestionCheckboxes,
            QuestionInputs,
            VueCountdown
        },

        data() {
            return {
                loading: true,
                stepsCount: 10,
                currentStepNumber: 0,
                currentStep: {
                    id: 0
                },
                questions: [],
                answersList: {},
                stepCountdown: 65000,
                stepTime: 65
            }
        },

        mounted() {
            window.scrollTo(0, 0)
            this.currentStepNumber = LocalStorage.getStepNumber()
            this.currentStep.id = LocalStorage.getStepId()
            this.fetchStep(this.currentStep.id)
            this.fetchStepsCount()
        },

        computed: {
            progress() {
                return this.currentStepNumber * 100 / this.stepsCount
            },

            stepCountDownProgress() {
                return (this.currentStep.time - this.stepTime) * 100 / this.currentStep.time
            },

            stepAnswered() {
                // checking value in all answers, if all answers filled, than return true, else false
                let allAnswersGet = true
                Object.entries(this.answersList).forEach(([key, answer]) => {
                    if (!answer) {
                        allAnswersGet = false
                    } else if (Array.isArray(answer) && answer.length === 0) {
                        allAnswersGet = false
                    } else if (typeof answer === 'object') {
                        Object.entries(answer).forEach(([k, v]) => {
                            if (!v || 0 === v.length) {
                                allAnswersGet = false
                            }
                        })
                    }
                });
                return allAnswersGet
            }
        },

        methods: {
            async fetchStepsCount() {
                const countResponse = await Api.getStepsCount()
                this.stepsCount = countResponse.data.count
            },

            async fetchStep(step) {
                this.loading = true

                let stepResponse;
                if (step === 'next') {
                    stepResponse = await Api.getNextStepFor(this.currentStep.id)
                } else if (parseInt(step) > 0) {
                    stepResponse = await Api.getStep(step)
                } else {
                    stepResponse = await Api.getFirstStep()
                }

                const stepRemainingTime = LocalStorage.getStepRemainingTime(stepResponse.data.id, stepResponse.data.time)
                if (stepRemainingTime < 1) {
                    this.nextStep()
                } else {
                    this.stepCountdown = stepRemainingTime * 1000
                }

                this.currentStep = stepResponse.data
                this.setAnswersList(stepResponse.data.questions)

                LocalStorage.setStepId(stepResponse.data.id)
                this.loading = false
            },

            nextStep() {
                if (this.currentStepNumber >= this.stepsCount) {
                    this.finish()
                } else {
                    window.scrollTo(0, 0)
                    this.stepTime = this.currentStep.time
                    LocalStorage.addAnswers(this.answersList)
                    this.fetchStep('next')

                    AudioAPI.stop()
                    this.currentStepNumber++
                    LocalStorage.setStepNumber(this.currentStepNumber)
                }
            },

            setAnswersList(questionsList) {
                this.answersList = {}
                let storeAnswersList = LocalStorage.getAnswers()

                if (questionsList) {
                    questionsList.forEach((question) => {
                        const key = 'q' + question.id
                        let value

                        switch (question.type) {
                            case 'inputs':
                                if (storeAnswersList && storeAnswersList[key]) {
                                    value = storeAnswersList['q' + question.id]
                                } else {
                                    value = {}
                                    if (question.variants) {
                                        question.variants.forEach((variant) => {
                                            value[variant.part] = ''
                                        })
                                    }
                                }
                                break;

                            case 'checkbox':
                                if (storeAnswersList && storeAnswersList[key]) {
                                    value = storeAnswersList[key]
                                } else {
                                    value = []
                                }
                                break;

                            default:
                                if (storeAnswersList && storeAnswersList[key]) {
                                    value = storeAnswersList[key].toString()
                                } else {
                                    value = ''
                                }
                        }

                        this.$set(this.answersList, 'q' + question.id, value)
                    })
                }
            },

            onInputPart(answer) {
                let key = 'q' + answer.questionId
                if (this.answersList[key]) {
                    this.$set(this.answersList[key], answer.part, answer.value)
                }
            },

            finish() {
                window.scrollTo(0, 0)
                AudioAPI.stop();
                LocalStorage.addAnswers(this.answersList)
                this.$router.push({'name' : 'finish'});
            },

            handleCountdownProgress(data) {
                this.stepTime = data.totalSeconds
            },

            startCountdown() {
                LocalStorage.setStepStartTime(this.currentStep.id)
                this.$refs.countdown.start()
            },

            transformCountdown(props) {
                Object.entries(props).forEach(([key, value]) => {
                    // Adds leading zero
                    props[key] = value < 10 ? `0${value}` : value;
                });
                return props;
            },

            resetTestData() {
                LocalStorage.clear()
            }
        }
    }
</script>
